var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"registration-header"},_vm._l((_vm.filteredNavigationTabs),function(tab,index){return _c('RegistrationHeaderTab',{key:index,attrs:{"navigation-tab":tab}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }